import React from 'react';
import dayjs from 'dayjs';
import { DatePicker, Select } from 'antd';
import { UserRound, Mail, Phone, Calendar } from 'lucide-react';
import { PageHeader, StatusTag } from '../../../common';
import { t } from '../../../../company/labels';

const { RangePicker } = DatePicker;

function PromoterTitle({ promotor, date, dateRange, filterMode, setDate, setDateRange, setFilterMode, setLoading }) {
    return (
        <PageHeader
            className="!mb-2"
            icon={<UserRound />}
            title={promotor?.name}
            description={
                <span className="flex flex-wrap items-center gap-x-4 gap-y-1">
                    <a href={`mailto:${promotor?.email}`} className="inline-flex items-center gap-1.5 text-surface-600 hover:text-primary-600">
                        <Mail className="text-surface-400" />
                        {promotor?.email}
                    </a>
                    {promotor?.phone && (
                        <span className="inline-flex items-center gap-1.5 text-surface-600" title="Teléfono">
                            <Phone className="text-surface-400" />
                            <span className="sr-only">Teléfono</span>
                            {promotor.phone}
                        </span>
                    )}
                </span>
            }
            meta={
                <>
                    <StatusTag tone="success">{t('promotor')}</StatusTag>
                    {promotor?.active !== undefined && (
                        <StatusTag tone={promotor.active ? 'success' : 'neutral'} dot>
                            {promotor.active ? 'Activo' : 'Inactivo'}
                        </StatusTag>
                    )}
                </>
            }
            actions={
                <div className="flex flex-col gap-1">
                    <span className="flex items-center gap-1.5 text-xs font-medium text-surface-500">
                        <Calendar />
                        Fecha de revisión
                    </span>
                    <div className="flex flex-wrap items-center gap-2">
                        <Select
                            value={filterMode}
                            onChange={(value) => {
                                setFilterMode(value);
                                setLoading(true);
                            }}
                            className="w-32"
                            options={[
                                { value: 'day', label: 'Un día' },
                                { value: 'range', label: 'Rango' }
                            ]}
                        />
                        {filterMode === 'range' ? (
                            <RangePicker
                                allowClear={false}
                                value={dateRange}
                                onChange={(value) => {
                                    if (value && value[0] && value[1]) {
                                        setDateRange(value);
                                        setLoading(true);
                                    }
                                }}
                            />
                        ) : (
                            <DatePicker
                                allowClear={false}
                                value={dayjs(date)}
                                onChange={(e) => {
                                    setDate(dayjs(e));
                                    setLoading(true);
                                }}
                            />
                        )}
                    </div>
                </div>
            }
        />
    );
}

export default PromoterTitle;
